import React from 'react';
import { omitNonReactProps } from '~/services/utils';
import { IconProps } from '~/types/utils';
import { useTheme } from 'styled-components';

const YouTube = ({ fill, size = '24', ...otherProps }: IconProps) => {
	const theme = useTheme();
	return (
		<svg
			focusable="false"
			aria-hidden="true"
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill={fill ?? theme.colors.icon}
			{...omitNonReactProps(otherProps)}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.6074 5.45898C21.5508 5.70605 22.293 6.42969 22.5469 7.34668C23.0176 9.02344 23 12.5176 23 12.5176C23 12.5176 23 15.9941 22.5469 17.6709C22.293 18.5879 21.5508 19.3115 20.6074 19.5586C18.8867 20 12 20 12 20C12 20 9.3125 20 6.87305 19.8877C5.41406 19.8203 4.04297 19.7129 3.39258 19.541C2.44922 19.2939 1.70703 18.5703 1.45313 17.6533C1 15.9941 1 12.5 1 12.5C1 12.5 1 11.377 1.08398 10.0996C1.14648 9.12988 1.25781 8.07031 1.45313 7.34668C1.58398 6.87109 1.85156 6.44336 2.20703 6.10645C2.53906 5.79395 2.94727 5.56055 3.39258 5.44141C5.11328 5 12 5 12 5C12 5 14.0977 5 16.2676 5.07715C18.0293 5.13965 19.8359 5.25293 20.6074 5.45898ZM9 9L16 12L9 15V9Z"
			/>
		</svg>
	);
};

export default YouTube;
